import React, { useContext, useEffect, useState } from 'react';
// import { isHWAChatEndRoute } from '../../helpers';
import { ContractContext } from '../contexts/ContractContext';
import Footer from '../Vendor/Apple/Footer';
import { HWAFooter } from './HWAFooter/HWAFooter';
import { ETFooter } from './ETFooter/ETFooter';
import { CutlerFooter } from './CutlerFooter/CutlerFooter';
import ConstellationFooter from './ConstellationFooter/ConstellationFooter';
import SibiFooter from './SibiFooter/SibiFooter';
import HomekickFooter from './HomekickFooter/HomekickFooter';
import RateFooter from './RateFooter/RateFooter';
import ApplestandaloneFooter from './ApplestandaloneFooter/ApplestandaloneFooter';
import FlexFooter from './FlexFooter/FlexFooter';
import SureFooter from './SureFooter/SureFooter';

export const FooterController = () => {
    const {
        data: { clientId }
    } = useContext(ContractContext);

    // useEffect(() => {
    //     if (brandContext.clientId !== null) {
    //         setClientId(brandContext.clientId.toLowerCase());
    //     } else {
    //         const hwaChat = async () => {
    //             const result = await isHWAChatEndRoute();
    //             console.log(result);
    //             if (result == true) {
    //                 setClientId('hwa');
    //             }
    //         };
    //         hwaChat();
    //     }
    // }, []);

    switch (clientId?.toLowerCase()) {
        case 'hwa':
            return <HWAFooter />;
        case 'et':
            return <ETFooter />;
        case 'cutler':
            return <CutlerFooter />;
        case 'constellation':
            return <ConstellationFooter />;
        case 'sibi':
            return <SibiFooter />;
        case 'homekick':
            return <HomekickFooter />;
        case 'rate':
            return <RateFooter />;
        case 'applestandalone':
            return <ApplestandaloneFooter />;
        case 'flex':
            return <FlexFooter />;
        case 'sure':
            return <SureFooter />;
        case 'arw':
        case 'aig':
        case 'apple':
        default:
            return <Footer />;
    }
};
